import { Button, Modal } from "antd";
import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import { Trans, useTranslation } from "react-i18next";
import { envChangeType, envType } from "../plugins/utils";
import { UserAgentContextType } from "./data";
import styles from "./styles.module.scss";

const UserAgentContext = createContext<UserAgentContextType>({
  showUserAgentPopup: false,
  setShowUserAgentPopup: () => {},
});

type UserAgentContextProviderType = PropsWithChildren & {};

export const UserAgentContextProvider = ({
  children,
}: UserAgentContextProviderType) => {
  const { t } = useTranslation();
  const [showUserAgentPopup, setShowUserAgentPopup] = useState<boolean>(false);
  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isChrome = userAgent.includes("Chrome") && !userAgent.includes("Edg"); // Exclude Edge which also contains "Chrome"
    const isSafari =
      userAgent.includes("Safari") && !userAgent.includes("Chrome"); // Exclude Chrome which also contains "Safari" on some platforms
    const isFirefox = userAgent.includes("Firefox");
    const isOpera = userAgent.includes("Opera") || userAgent.includes("OPR"); // OPR for Opera Touch
    const isEdge = userAgent.includes("Edg"); // Microsoft Edge
    const isIE = userAgent.includes("MSIE") || userAgent.includes("Trident"); // Internet Explorer
    const isLinaApp =
      userAgent.toLowerCase().includes("line") ||
      userAgent.toLowerCase().includes("lineapp");

    if (
      envChangeType("REACT_APP_OPEN_USER_AGENT_CHECK", envType.BOOLEAN) === true
    ) {
      if (isLinaApp === true) {
        setShowUserAgentPopup(true);
      } else {
        setShowUserAgentPopup(false);
      }
    }
  }, []);

  const closeModal = () => {
    setShowUserAgentPopup(false);
  };

  return (
    <UserAgentContext.Provider
      value={{
        showUserAgentPopup,
        setShowUserAgentPopup,
      }}
    >
      {children}
      <Modal
        open={showUserAgentPopup}
        footer={false}
        onCancel={closeModal}
        onClose={closeModal}
      >
        <div className={styles.uaPopupContent}>
          <div className={styles.uaPopupDesc}>
            <Trans
              i18nKey={"browser.information"}
              components={{
                span: <span />,
              }}
            />
          </div>
          <div className={styles.uaPopupButtonContainer}>
            <Button type="primary" size="small" onClick={closeModal}>
              {t("browser.understand")}
            </Button>
          </div>
        </div>
      </Modal>
    </UserAgentContext.Provider>
  );
};

export const useUserAgent = () => {
  const UserAgentValue = useContext(UserAgentContext);
  return UserAgentValue;
};
